import { createSlice } from '@reduxjs/toolkit';

// Slice
const slice = createSlice({
  name: 'vendor',
  initialState: {
    vendor: null,
  },
  reducers: {
    setVendor: (state, { payload }) => {
      state.vendor = payload;
    },
  },
});

// Actions
export const { setVendor } = slice.actions;

export default slice.reducer;